import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=3872b71e&scoped=true&"
import script from "./Widget.vue?vue&type=script&lang=ts&"
export * from "./Widget.vue?vue&type=script&lang=ts&"
import style0 from "./Widget.vue?vue&type=style&index=0&id=3872b71e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3872b71e",
  null
  
)

export default component.exports